// Предупреждение о совпадении: этот человек, возможно, уже заведён.
//
// Это ПРЕДУПРЕЖДЕНИЕ, а не отказ, и текст обязан звучать именно так. У заказчика встречаются
// полные тёзки, а телефон указан не у всех: запрет по совпадению телефона заблокировал бы
// заведение настоящего второго человека, а молчание завело бы третью карточку тому же
// Старцеву. Поэтому — назвать, по чему совпало, и дать ссылку на найденную карточку.
// Решение принимает человек.

import { RiAlertLine } from '@remixicon/react';
import { Link } from 'react-router';

import type { DuplicateReport } from '@/shared/api/endpoints/people';
import * as Alert from '@/shared/ui/alert';

import { DEFAULT_VIEW, peopleHref } from '../route';

const MATCH_WORDS: Readonly<Record<'phone' | 'document', string>> = {
  phone: 'по телефону',
  document: 'по паспорту',
};

export interface DuplicateNoticeProps {
  report: DuplicateReport;
  /**
   * Что делать дальше, словами под совпадениями. У мастера и у карточки это разные вещи:
   * в мастере человек ещё может передумать, в карточке она уже создана.
   */
  note: string;
}

export function DuplicateNotice({ report, note }: DuplicateNoticeProps) {
  const hits = report.hits ?? [];
  if (!report.found || hits.length === 0) {
    return null;
  }
  return (
    <Alert.Root variant='light' status='warning' size='small' role='status'>
      <Alert.Icon as={RiAlertLine} />
      <div className='flex min-w-0 flex-col gap-1'>
        <span>
          {hits.length === 1
            ? 'Похоже, такой человек уже заведён'
            : `Похожих карточек найдено: ${hits.length}`}
        </span>
        <ul className='flex flex-col gap-0.5'>
          {hits.map((hit) => (
            <li key={hit.employee_id}>
              <Link
                to={peopleHref(DEFAULT_VIEW, { filters: {}, panels: [] }, hit.employee_id)}
                className='text-primary-base underline тач:inline-flex тач:min-h-11 тач:items-center'
              >
                {hit.display_name}
              </Link>
              <span className='text-paragraph-xs opacity-80'>
                {' '}
                — совпало {MATCH_WORDS[hit.matched_by]}
              </span>
            </li>
          ))}
        </ul>
        <span className='text-paragraph-xs opacity-80'>{note}</span>
      </div>
    </Alert.Root>
  );
}
